import { SsoUrls, getLocalizedUrl } from '../default';
import SP_ENTITY_IDS from '../../ForgeRockSSOEndpoints';
import { ENV } from '../../../../context';

const baseMemberUrl = 'https://www.sentarahealthplans.com';
const getMemberBaseUrl = () => getLocalizedUrl(baseMemberUrl);
export const memberBaseUrl = getMemberBaseUrl();
const forgeRockBaseUrl = process.env.REACT_APP_FORGEROCK_BASE_URL;

const getSentaraSSOUrls = (): Partial<SsoUrls> => {
    const memberBaseUrl = getMemberBaseUrl();
    return {
        healthSavingAccounts:
          forgeRockBaseUrl +
          '/am/idpssoinit?metaAlias=/alpha/SHP_HealthEquity&spEntityID=' +
          SP_ENTITY_IDS[ENV]?.healthSavingAccountsId,
        HealthReimbursementAccount:
          forgeRockBaseUrl +
          '/am/idpssoinit?metaAlias=/alpha/SHP_HealthEquity&spEntityID=' +
          SP_ENTITY_IDS[ENV]?.healthReimbursementAccountId,
        DentalDominion:
          forgeRockBaseUrl +
          '/am/idpssoinit?metaAlias=/alpha/SHP_Cova&spEntityID=' +
          SP_ENTITY_IDS[ENV]?.DentalDominionId,
        ViewCarePlan:
          forgeRockBaseUrl +
          '/am/idpssoinit?metaAlias=/alpha/SHP_ZeOmega_Jiva&spEntityID=' +
          SP_ENTITY_IDS[ENV]?.viewCarePlanId,
        vlocityEnrollBenefits:
          forgeRockBaseUrl +
          '/am/XUI/?realm=alpha&authIndexType=service&authIndexValue=' +
          SP_ENTITY_IDS[ENV]?.vlocityEnrollBenefitsId,
        manageRenewPolicy:
          forgeRockBaseUrl +
          '/am/idpssoinit?metaAlias=/alpha/SHP_Siebel&spEntityID=' +
          SP_ENTITY_IDS[ENV]?.manageRenewPolicyId,
        PayMonthlyPremium: 'WellsFargo',
        memberHome: memberBaseUrl + '/members/',
        fitnessURL: 'https://www.activeandfitdirect.com/fitness/AF560566SE',
        hingeHealthURL: forgeRockBaseUrl + '/am/idpssoinit?metaAlias=%2Falpha%2Fhingehealth&spEntityID=' + SP_ENTITY_IDS[ENV]?.hingeHealthId,
        termAndCondition: memberBaseUrl + '/company/policies/terms-of-use-and-disclaimer',
        languagesAssistance: memberBaseUrl + '/company/policies/language-assistance',
        footerNoticeOfNonDiscrimination: memberBaseUrl + '/notice-of-nondiscrimination',
        accessibility: "#",
        contactUs: memberBaseUrl + '/company/about/contact-sentara-health-plans',
        virtualVisitUrl: '/home/virtual-visit-care',
        VirtualVisitSSO: 'MDLiveSSOUrl',
        CalculateTreatmentCostUrl: 'CalculateTreatmentCostSSOUrl',
        individualOnAddressChangeUrl: 'https://www.marketplace.virginia.gov/existing-customers',
        alternativeAddressForm: 'https://shc-p-001.sitecorecontenthub.cloud/api/public/content/7ac6aecae6674cd9a1d657c4393e9c2e?v=b031f3bb',
    };
};

// Export function instead of static object for dynamic language support
export { getSentaraSSOUrls };
// Keep static export for backward compatibility (will be stale)
export const SENTARA_SSO_URLS: Partial<SsoUrls> = getSentaraSSOUrls();
